<script>
    import { messages } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/messages.js?1733898724820';
    import Message from '/srv/web/wyvr/html/releases/58819/gen/client/shop/messages/Message.svelte?1733898724820';
    import { slide } from 'svelte/transition';
    import { onMount } from 'svelte';

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    onMount(() => {
        on('message', (data) => {
            if (data) {
                messages.push(data.message, data.type, data.options);
            }
        });
    });
</script>

{#if $messages}
    <section class="messages">
        {#each $messages as message}
            <div transition:slide>
                <Message {message} />
            </div>
        {/each}
    </section>
{/if}


<style>
    .messages {
        position: fixed;
        max-width: 768px;
        width: 100%;
        left: 50%;
        top: 4vh;
        padding: var(--space);
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        z-index: 20000;
        opacity: 0.9;
        pointer-events: none;
    }
    .messages :global(> *) {
        pointer-events: all;
    }
</style>